import { LbaItemTag } from "@/components/SearchForTrainingsAndJobs/components/LbaItemTag"

export const TagCfaDEntreprise = () => {
  return (
    <LbaItemTag color="green" iconImageUri="/images/smiley.svg">
      CFA D&apos;ENTREPRISE
    </LbaItemTag>
  )
}
